import React from 'react';
import { motion } from 'framer-motion';
import { ScrollText } from 'lucide-react';

export default function Terms() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-2xl shadow-lg p-8"
        >
          <div className="flex items-center gap-4 mb-8">
            <ScrollText className="w-8 h-8 text-purple-600" />
            <h1 className="text-3xl font-bold text-gray-900">
              Regulamin
            </h1>
          </div>

          <div className="prose prose-purple max-w-none">
            <p className="lead">
              Niniejszy regulamin określa zasady korzystania z platformy Kariera z AI.
            </p>

            <h2>§1. Definicje</h2>
            <p>
              1.1. <strong>Platforma</strong> - serwis internetowy dostępny pod adresem karierazai.pl
            </p>
            <p>
              1.2. <strong>Użytkownik</strong> - osoba korzystająca z Platformy
            </p>

            <h2>§2. Postanowienia ogólne</h2>
            <p>
              2.1. Korzystanie z Platformy jest dobrowolne i bezpłatne w podstawowym zakresie.
            </p>
            <p>
              2.2. Do korzystania z Platformy wymagane jest posiadanie aktywnego konta email.
            </p>

            <h2>§3. Rejestracja</h2>
            <p>
              3.1. Rejestracja na Platformie jest dobrowolna i bezpłatna.
            </p>
            <p>
              3.2. Użytkownik zobowiązuje się do podania prawdziwych danych podczas rejestracji.
            </p>

            <h2>§4. Zasady korzystania</h2>
            <p>
              4.1. Użytkownik zobowiązuje się do korzystania z Platformy zgodnie z prawem i dobrymi obyczajami.
            </p>
            <p>
              4.2. Zabrania się dostarczania treści o charakterze bezprawnym.
            </p>

            <h2>§5. Odpowiedzialność</h2>
            <p>
              5.1. Administrator nie ponosi odpowiedzialności za:
            </p>
            <ul>
              <li>Przerwy w działaniu Platformy wynikające z przyczyn technicznych</li>
              <li>Działania Użytkowników niezgodne z regulaminem</li>
              <li>Skutki decyzji podjętych przez Użytkowników na podstawie analiz AI</li>
            </ul>

            <h2>§6. Własność intelektualna</h2>
            <p>
              6.1. Wszelkie prawa własności intelektualnej do Platformy należą do Administratora.
            </p>
            <p>
              6.2. Zabronione jest kopiowanie i rozpowszechnianie treści bez zgody Administratora.
            </p>

            <h2>§7. Zmiany regulaminu</h2>
            <p>
              7.1. Administrator zastrzega sobie prawo do zmiany regulaminu.
            </p>
            <p>
              7.2. O zmianach Użytkownicy będą informowani z 14-dniowym wyprzedzeniem.
            </p>

            <h2>§8. Postanowienia końcowe</h2>
            <p>
              8.1. W sprawach nieuregulowanych regulaminem stosuje się przepisy prawa polskiego.
            </p>
            <p>
              8.2. Regulamin wchodzi w życie z dniem 14.03.2024.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
